"use client"; // Error components must be Client Components
import { useEffect } from "react";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Button, Callout, Flex } from "@radix-ui/themes";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Flex
      p="6"
      direction="column"
      flexGrow="1"
      className="bg-gray-100 min-h-screen"
      align="center"
    >
      <Flex direction="column" gap="4" align="center" mt="9">
        <Callout.Root color="red" size="3" role="alert">
          <Callout.Icon>
            <ExclamationTriangleIcon fontSize="20px" />
          </Callout.Icon>
          <Callout.Text>An error occurred</Callout.Text>
        </Callout.Root>

        <Link href="/">
          <Button>Go Home</Button>
        </Link>
      </Flex>
    </Flex>
  );
}
